<ng-container *ngIf="filter.optionsWithMatches.length > 1">
    <p class="flex flex-justify-between col-1 p3"
       [ngSwitch]="filter.hasSelection">
        <span>
            <ng-container *ngSwitchCase="false">{{'Select %' | translate : (filter.id | attributeLabel)}}
            </ng-container>
            <ng-container *ngSwitchCase="true">{{filter.id | attributeLabel}}: {{currentColorValue ||
                filter.selection?.[0]
                | optionLabel: filter.id}}</ng-container>
        </span>

        <!-- Size guide -->
        <icon-label class="cursor-pointer"
                    (click)="openSizeGuideModal()"
                    *ngIf="filter.id === 'size'">{{'Size guide' | translate}}</icon-label>
    </p>

    <ng-container [ngSwitch]="!!filter.attribute.data?.isSwatch">

        <div class="p-b-2"
             *ngSwitchCase="true">
            <ng-container *ngFor="let option of allowedOptions; trackBy filter.optionTrackByFn">
                <swatch class="inline-block va-m cursor-pointer m-t-1 m-r-1"
                        [option]="option"
                        [value]="option.value"
                        [attributeCode]="filter.id"
                        [selected]="filter.isSelected(option) || currentColorValue === option.value"
                        (mouseenter)="updateColorOnMouseEnter(option.value)"
                        (mouseleave)="updateColorOnMouseLeave()"
                        (click)="selectFilterAndUpdate(option)"></swatch>
            </ng-container>
        </div>

        <div class="p-b-1"
             *ngSwitchDefault>
            <ng-container *ngFor="let option of allowedOptions; trackBy filter.optionTrackByFn">
                <box class="inline-block va-m cursor-pointer m-t-1 m-r-1"
                     [selected]="filter.isSelected(option)"
                     [disabled]="filter.isUnavailble(option)"
                     (click)="selectFilterAndUpdate(option)">
                    <span class="p3">{{option.value | optionLabel: filter.id}}</span>
                </box>
            </ng-container>
        </div>

    </ng-container>
</ng-container>

<ng-container *ngIf="filter.optionsWithMatches.length <= 1">
    <div class="flex flex-justify-between">
        <span class="col-12 p2"
              *ngFor="let option of allowedOptions; let isLast = last; trackBy filter.optionTrackByFn">
            {{option.value | optionLabel: filter.id}}
        </span>

        <icon-label class="cursor-pointer"
                    (click)="openSizeGuideModal()"
                    *ngIf="filter.id === 'size'">{{'Size guide' | translate}}</icon-label>
    </div>
</ng-container>